<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
    [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg">

    <ng-container *ngIf="consulta">
        <div class="body">
            <!-- <div class="card-msg d-flex flex-column flex-md-row px-1">
                <ul class="card-list py-1 card-pendencia">
                    <li class="border-none">
                        <span class="text-secondary format-compacta">OCORRÊNCIA MAIS ANTIGA:</span>
                        <span
                            class="text-uppercase format-compacta">{{ consulta?.resumoGeral?.dtOcorrenciaAntiga || msgNull }}</span>
                    </li>
                    <li class="border-none">
                        <span class="text-secondary format-compacta">OCORRÊNCIA MAIS RECENTE:</span>
                        <span
                            class="text-uppercase format-compacta">{{ consulta?.resumoGeral?.dtOcorrenciaRecente || msgNull }}</span>
                    </li>
                    <li class="border-none">
                        <span class="text-secondary format-compacta">VALOR TOTAL:</span>
                        <span class="text-uppercase format-compacta">
                            <span *ngIf="consulta?.resumoGeral?.valorTotal">R$:</span>
                            {{ consulta?.resumoGeral?.valorTotal || msgNull }}
                        </span>
                    </li>
                </ul>
            </div> -->

            <ng-container *ngFor="let r of consulta?.registros; let i = index">
                <h2 class="subtitle subtitle-{{status}}">PENDÊNCIA {{i+1}}</h2>
                <ul class="card-list-striped py-1">
                    <li>
                        <span class="text-secondary">DATA DA OCORRÊNCIA:</span>
                        <span class="text-uppercase">{{ r?.data_ocorrencia || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">MODALIDADE:</span>
                        <span class="text-uppercase">{{ r?.modalidade || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">VALOR:</span>
                        <span class="text-uppercase">{{ r?.valor || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">CONTRATO:</span>
                        <span class="text-uppercase">{{ r?.contrato || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">AVALISTA:</span>
                        <span class="text-uppercase">{{ r?.avalista || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">ORIGEM:</span>
                        <span class="text-uppercase">{{ r?.origem || msgNull }}</span>
                    </li>
                    <li>
                        <span class="text-secondary">CIDADE:</span>
                        <span class="text-uppercase">{{ r?.cidade || msgNull }}</span>
                    </li>
                </ul>
            </ng-container>

        </div>
    </ng-container>

</app-card-consulta>